import { FC, useState } from 'react';
import { Tabs } from 'antd';

import { useAppSelector, useTranslate } from 'hooks';
import { selectUser } from 'selectors';

import { Deposit } from './Deposit';
import { Withdrawal } from './Withdrawal';
import { BearLossCalculatorModal } from '../Overview/BearLossCalculator/BearLossCalculatorModal';

import s from './index.module.scss';

export const Funding: FC = () => {
	const user = useAppSelector(selectUser);

	const [type, setType] = useState('deposit');
	const [isOpen, serIsOpen] = useState(!user.riskTolerance?.value);

	const { depositText, withdrawText } = useTranslate(['depositText', 'withdrawText']);

	return (
		<div className={s.funding}>
			<Tabs
				className="accountTabs"
				type="card"
				defaultActiveKey={type}
				activeKey={type}
				onChange={(v: any) => setType(v)}
			>
				<Tabs.TabPane tab={depositText} key="deposit">
					<Deposit />
				</Tabs.TabPane>

				<Tabs.TabPane tab={withdrawText} key="withdraw">
					<Withdrawal onAddFunds={() => setType('deposit')} />
				</Tabs.TabPane>
			</Tabs>

			<BearLossCalculatorModal isOpen={isOpen} onClose={() => serIsOpen(false)} />
		</div>
	);
};
